import React from "react";
import { Row, Col } from "react-bootstrap";
import editprofile from "assets/images/edit-profile.svg";
import profileuploads from "assets/images/profileuploads.png";

const DocumentSection = ({ user, onOpenModal }) => {
    return (
        <Row>
            <Col lg={6} className="mb-30">
                <div className="profile-cards">
                    <div className="profie-heding">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4>FAA Remote Pilot License #</h4>
                            <div
                                onClick={() =>
                                    onOpenModal({
                                        key: "faaRegistration",
                                        title: "Upload FAA Remote Pilot License #",
                                        type: "FAA",
                                    })
                                }
                            >
                                <img src={editprofile} className="cursor-pointer" alt="Edit" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="p-20 mx-auto upload-p">
                            <img
                                src={`${user?.baseS3Url}${user?.faaRegistration || ""}`}
                                alt="FAA Drone Registration"
                                className="img-fluid mx-auto d-block"
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = profileuploads;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Col>
            <Col lg={6} className="mb-30">
                <div className="profile-cards">
                    <div className="profie-heding">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4>Driver’s License</h4>
                            <div
                                onClick={() =>
                                    onOpenModal({
                                        key: "drivingLicense",
                                        title: "Driver’s License",
                                        type: "DL",
                                    })
                                }
                            >
                                <img src={editprofile} alt="Edit" className="cursor-pointer" />
                            </div>
                        </div>
                    </div>
                    <div className="p-20 mx-auto upload-p">
                        <img
                            src={`${user?.baseS3Url}${user?.drivingLicense || ""}`}
                            alt="Driver's License"
                            className="img-fluid mx-auto d-block"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = profileuploads;
                            }}
                        />
                    </div>
                </div>
            </Col>
            <Col lg={6}>
                <div className="profile-cards">
                    <div className="profie-heding">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4>Proof Of Insurance</h4>
                            <div
                                onClick={() =>
                                    onOpenModal({
                                        key: "insuranceProof",
                                        title: "Proof Of Insurance",
                                        type: "INSURANCE",
                                    })
                                }
                            >
                                <img src={editprofile} alt="Edit" className="cursor-pointer" />
                            </div>
                        </div>
                    </div>
                    <div className="p-20 mx-auto upload-p">
                        <img
                            src={`${user?.baseS3Url}${user?.insuranceProof || ""}`}
                            alt="Insurance Proof"
                            className="img-fluid mx-auto d-block"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = profileuploads;
                            }}
                        />
                    </div>
                </div>
            </Col>
            <Col lg={6}>
                <div className="profile-cards">
                    <div className="profie-heding">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4>Pilot License</h4>
                            <div
                                onClick={() =>
                                    onOpenModal({
                                        key: "pilotLicense",
                                        title: "Pilot License",
                                        type: "PILOT_LICENSE",
                                    })
                                }
                            >
                                <img src={editprofile} alt="Edit" className="cursor-pointer" />
                            </div>
                        </div>
                    </div>
                    <div className="p-20 mx-auto upload-p">
                        <img
                            src={`${user?.baseS3Url}${user?.pilotLicense || ""}`}
                            alt="Pilot License"
                            className="img-fluid mx-auto d-block"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = profileuploads;
                            }}
                        />
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default DocumentSection;
